import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import axios from 'axios';
import Utils from './app.utilities';
import { USER_ROLES } from './app.config';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

const utilities = new Utils();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  router: Router;

  constructor(router: Router, translate: TranslateService) {
    this.router = router;
    translate.setDefaultLang('en');
    translate.addLangs(environment.locale);

    const locale = localStorage.getItem('locale');
    if (locale) {
      translate.use(locale);
    } else {
      const browserLang = translate.getBrowserLang();
      if (browserLang.match(/en|sl/)) {
        translate.use(browserLang);
        localStorage.setItem('locale', browserLang);
      } else {
        translate.use('en');
        localStorage.setItem('locale', 'en');
      }
    }
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      localStorage.setItem('locale', event.lang);
    });
  }

  ngOnInit() {
    axios.interceptors.request.use(
      config => {
        config.headers['Authorization'] = utilities.getStorage('token');
        return config;
      },
      error => {
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response.status === 401) {
          utilities.removeFromStorage('token');
          this.router.navigate(['']);
        }
        return Promise.reject(error);
      },
    );
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/app.component.ts